import React from 'react';
import styles from './index.module.scss';

type ProductFunctionProps = {
  id?: string;
  functionContent?: string;
};

const ProductFunction: React.FC<ProductFunctionProps> = ({ id = 'productFunction', functionContent }) => {
  return (
    <section className={styles.section}>
      <h2 id={id} className={styles.title}>
        产品功能
      </h2>
      <div
        className={styles.functionContent}
        data-class="editor-content"
        dangerouslySetInnerHTML={{ __html: functionContent }}
      ></div>
    </section>
  );
};
export default ProductFunction;
